import { PRODUCT_DETAILS, PRODUCT_TYPES } from "../constants";

// given the availabile product packages, return the selected product
// defaults to the first product otherwise

function _getQualifyingCondition(product, productDetail) {
	switch (productDetail.name) {
		case PRODUCT_DETAILS.ID: {
			return product[PRODUCT_DETAILS.ID] === productDetail.value;
		}

		case PRODUCT_DETAILS.TOKENS_NUM: {
			return parseInt(product[PRODUCT_DETAILS.TOKENS_NUM], 10) ===
				parseInt(productDetail.value, 10);
		}

		case PRODUCT_DETAILS.SUB_PERIOD: {
			return parseInt(product[PRODUCT_DETAILS.SUB_PERIOD], 10) ===
				parseInt(productDetail.value, 10);
		}

		default: {
			return false;
		}
	}
}

export default function getSelectedProduct(productPackages, productDetail) {
	return (
		productPackages
			.filter((p) => _getQualifyingCondition(p, productDetail))
			.reduce((memo, p) => p, null)
	) || productPackages[0];
}

const PRODUCT_FILTER_KEY = {
	[PRODUCT_TYPES.SUBSCRIPTION]: "subPeriod",
	[PRODUCT_TYPES.TOKEN]: "tokensCount",
};

/**
 * @param {array} products - A list of products.
 * @param {string} productType - subscription, token, etc.
 * @param {number} value - the subscription period or the token count.
 * @returns {object} A singular product
 */
export function getSelectedProductByValue(products, productType, value) {
	const filterKey = PRODUCT_FILTER_KEY[productType];
	return products.find((product) => product[filterKey] === value)
		|| products[0];
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getSelectedProduct.js